Backbone.Radio.channel('ads').on('show',function(type){
//Backbone.Radio.channel('ads').reply('show',function(type){
    
    //console.log('type',type)
	var t = "";
	var target = "";
	var sizes = [];

    switch(type){
	    case 'station':
	    case 'radio':
	    	t = "radio";
	    	target='div-gpt-ad-radio';
	    	sizes = [[468, 60],[234, 60],[300,250]];
	    	break;
	    case 'tv':
	    	t = "tv";
	    	target='div-gpt-ad-tv';
	    	sizes = [[728, 90],[300,250]];
	    	break;
	    case 'station-tv':
	    	t = "station-tv";
	    	target='div-gpt-ad-station-tv';
	    	sizes = [[300,250]];
	    	break;
    }
    
    if(t){    
	    googletag.cmd.push(function(){
		    /*  
				The minimum viewport size an ad can display at,
				followed by the ad size(s) that is allowed.
				[800,0],[[728, 90],[300, 250]] would allow for either ad-size to appear, preferring 728x90.
				[0,0] is anything
				
				$xs:0;
				$sm: 576px;
				$md: 768px;
				$lg: 992px;
				$xl: 1200px;
			*/
			var mapping;
			if(t==='radio'){
				mapping = googletag.sizeMapping()
					.addSize([992,0],[468, 60])
					.addSize([768,0],[234, 60])
					.addSize([576,0],[[234, 60],[300, 250]])
					.addSize([0,0], [300, 250]).build();
			} else if(t==='station-tv') {
				mapping = googletag.sizeMapping()
					.addSize([0,0], [300, 250]).build();
			}else{
				mapping = googletag.sizeMapping()
					.addSize([800,0],[728, 90])
					.addSize([0,0], [300, 250]).build();
			}
			googletag.defineSlot('/3405737/mpresponsive', sizes, target)
				.defineSizeMapping(mapping)
				.addService(googletag.pubads());
			if(t==='station-tv') {
				googletag.pubads().setTargeting('section','kids');
			}
			googletag.pubads().enableSingleRequest();
			googletag.pubads().collapseEmptyDivs();
			googletag.enableServices();			
		});
		googletag.cmd.push(function() { googletag.display(target); });
	}
});

